import { get } from "lodash"
import { SelectedBasket } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { OkReduxDataResult } from "model/state"
import { CompositionByNode, getCompositionType } from "./composition"
import { PositionSetMetadata } from "./types"

interface BasketData {
  swap: {
    description: string
    availableFrom: IsoDate
    terminationDate: IsoDate | null
  }
  model: {
    simulation: {
      composition: [{
        compositionBy: CompositionByNode
      }]
    }
  }
}

export interface BasketMetadata extends PositionSetMetadata {
  type: "SWAP"
}

const BASKET_QUERY = `query ($modelId: String!, $ticker: String!, $currentDate: Date!, $segment: Segment) {
  swap (ticker: $ticker) {
    description
    availableFrom
    terminationDate
  }
  model (id: $modelId) {
    simulation (positionSet: {
      type: SWAP,
      id: $ticker,
      segment: $segment
    }, from: $currentDate, to: $currentDate) {
      composition {
        compositionBy (groupBy: LONG_SHORT) {
          id
        }
      }
    }
  }
}`

function basketSelect(data: OkReduxDataResult<BasketData>, metadataDate: IsoDate): BasketMetadata {
  return {
    name: get(data, "data.swap.description"),
    earliestDate: get(data, "data.swap.availableFrom"),
    unavailable: get(data, "apiMessages.errors.0.message", "").startsWith("Invalid swap ticker:"),
    type: "SWAP",
    compositionType: getCompositionType(data),
    latestDate: get(data, "data.swap.terminationDate", metadataDate),
  }
}

export function getBasketQueryDefinition(positionSet: SelectedBasket, modelId: string, metadataDate: IsoDate) {
  const variables = { ticker: positionSet.id, modelId, currentDate: metadataDate, segment: positionSet.segment }

  return {
    query: BASKET_QUERY,
    variables,
    queryKey: ["position-set", "metadata", "basket", variables],
    select: (data: OkReduxDataResult<BasketData>) => basketSelect(data, metadataDate),
  }
}
